import { render, staticRenderFns } from "./DeclaracoesFederais.vue?vue&type=template&id=821db12a&"
import script from "./DeclaracoesFederais.vue?vue&type=script&lang=js&"
export * from "./DeclaracoesFederais.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracoesFederais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports